<template>
  <div id="mallAmount">

      <div class="d-flex pt-2 pl-2">
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">技术合同登记</span>
        </span>

      </div>
      <div class="d-flex jc-center body-box" style=" margin-top: 0.5rem;width: 100%;height:90%;">
        <div id="mallAChart1" style="width: 100%;height:94%;"></div>
      </div>
    </div>

</template>

<script>
// import centerRight2Chart1 from "@/components/echart/centerRight/centerRightChart";
import sciApi from '@/api/index.js'
let Chart
export default {
  data() {
    return {
      tag:'',
      options:{},
      Num:{
        // '2015':0,
        // '2016':0,
        // '2017':0,
        // '2018':0,
        // '2019':0,
        // '2020':0,
        // '2021':0,
        // '2022':0,
      },
      allAmount:0,
      allAmountList:[],
      val:[]
    };
  },
  watch:{
    setregion4:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val

      },
    },
    // tag:{
    //   immediate: false,
    //   deep: true,
    //   handler(val) {
    //     console.log(val,'val')
    //     this.init().then(()=>{
    //       let num= Object.values(this.Num)
    //       this.options.series[0].data=num
    //       Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    //     })
    //   },
    // },
  },
  computed:{
    setregion4() {
      return this.$store.state.region4
    }
  },
  // components: { centerRight2Chart1 },
  mounted() {
    this.tag=''
    // const chartTit = Object.keys(this.Num);
    this.init().then(()=>{
      let tum=[]
      let num=[]
      for(var i=0;i<this.val.length;i++){
        if (this.val[i].name !=='政策'){
          tum.push(this.val[i].name)
          num.push(this.val[i].value)
        }
      }
      this.options.xAxis.data=tum
      this.options.series[0].data=num
      Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    })
    //当前视口宽度
    let nowClientWidth = document.documentElement.clientWidth;
    // 换算方法
    let nowSize = function (val, initWidth = 1920) {
      return val * (nowClientWidth / initWidth);
    };
    this.options = {
      tooltip: {
        // 触发类型  经过轴触发axis  经过轴触发item
        trigger: 'item',
        // 轴触发提示才有效
        axisPointer: {
          // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果
          type: 'shadow'
        }
      },
      grid: {
        // 距离 上右下左 的距离
        left: '3%',
        right: '3%',
        bottom: '1%',
        top:'15%',
        // 大小是否包含文本【类似于boxsizing】
        containLabel: true,
        //显示边框
        show: false,
        //边框颜色
        borderColor: 'rgba(0, 240, 255, 0.3)'
      },
      xAxis: {
        // 使用类目，必须有data属性

        // 使用 data 中的数据设为刻度文字
        type: 'category',
        data: [],
        // 刻度设置
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false
        },
        axisLine:{
          show:true,
          lineStyle:{
            color:'#fff'
          },

        },
        //文字
        axisLabel: {
          color: '#fff',
          // interval: 0,
          fontSize: nowSize(14),
          // rotate: 30
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: 'rgb(28,59,160)',
            show:true
          }
        }
      },
      yAxis: {
        type: 'value',
        boundaryGap: false,
        // 使用数据的值设为刻度文字
        name: "单位（万元）",
        nameTextStyle: {
          nameLocation: "start",
        },
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false

        }, //坐标线
        axisLine:{
          show:true,
          lineStyle:{
            color:'#fff'
          }},
        //文字
        axisLabel: {
          color: '#fff',
          fontSize: nowSize(14),

        },
        splitLine: {
          show:false,
          lineStyle: {
            color: 'rgb(28,59,160)',
            show:true
          }
        },
      },
      series: [{
        barWidth: 30,
        // lineStyle: {
        //   color: '#4c9bfd',
        //   width: 2
        // },
        itemStyle: {
          normal: {
            // barBorderRadius:5,
            // color:function (params) {
            //   var colorList=[
            //     '#5efffa',
            //     '#339be9',
            //     '#fa7c36',
            //     // '#fe7c85',
            //     // '#ec515c',
            //     // '#ffd663',
            //     // '#fbc01b',
            //     // '#ab8fff',
            //     // '#8762f3'
            //   ]
            //   if (params.dataIndex >= colorList.length) {
            //     params.dataIndex = params.dataIndex - colorList.length
            //   }
            //   return colorList[params.dataIndex]
            // }
            // type: 'linear',
            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
              // { offset: 0, color: "#956FD4" },
              // { offset: 1, color: "#3EACE5" }
              { offset: 0, color: '#14c8d4'}, // 1 结束颜色
              { offset: 1, color: '#43eec6' }  // 0 起始颜色
            ])
          }
        },
        // areaStyle: {
        //   normal: {
        //     color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //       // { offset: 0, color: "#956FD4" },
        //       // { offset: 1, color: "#3EACE5" }
        //       { offset: 1, color: "rgba(35,184,210,0.6)" }, // 1 结束颜色
        //       { offset: 0, color: "rgba(35,184,210,0)" }  // 0 起始颜色
        //     ])
        //   }
        // },
        label: {
          show: true,
          position: 'top',
          color:'#fff',
          formatter: "{text|{c}}",
          rich: {
            text: {
              fontSize:nowSize(16),
              color: '#fff',
            }
          }
        },
        data: [],
        type: 'bar'
      }]
    };
    this.drawLine();

  },
  methods: {
      toThousands(num) {
        return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      },
    async init(){
      // await sciApi.selectMall({})
      //总金额
      // const that = this;
      await sciApi.selectScience({level1:'362164502503887971', pageNum:1, pageSize:1000}).then((data)=>{
        // data 就是接口返回值
        this.allAmountList = data.list || []
        this.val=[]
        this.allAmountList.forEach((item) => {
          this.Num[item.level2Display] = item
        })
        let names = Object.keys(this.Num)

        names.forEach(()=>{
          this.val.push({name:'政策',value:0})
        })
        console.log(names,'names')
        // 累加数据
        this.allAmountList.forEach((item) => {
          // console.log(item,'item')
          let idx = names.indexOf(item.level2Display)
          if (idx != -1) {
            // 首次全部累加
            this.val[idx].name = names[idx] || '政策'
            this.val[idx].value =item.mapNum||0
          }
        })
      })

    },
      drawLine:function (){
        Chart = this.$echarts.init(document.getElementById('mallAChart1'))
        Chart.setOption(JSON.parse(JSON.stringify(this.options)));
        // option && myChart.setOption(option);
      },
    },

};
</script>

<style lang="scss">
#mallAmount {
  padding: 0.2rem;
  width: 100%;height: 100%;
  //border-radius: 0.0625rem;
  .bg-color-black {
    padding: 0.0625rem;
    height: auto;
    border-radius: 0.125rem;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 0.125rem;
    overflow: hidden;
  }
}
</style>
